import React from 'react';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="landing-page">
      <h1>cloud.atxp.ai</h1>
      <p>
        ATXP Cloud is an experimental service that lets you host agents in a pay-per-use way,
        starting with agents built on the{' '}
        <a href="https://docs.claude.com/en/api/agent-sdk/overview" target="_blank" rel="noopener noreferrer">
          Claude Agent SDK
        </a>.
      </p>

      <h2>To try it out:</h2>

      <ol>
        <li>
          Customize Claude Code for yourself locally, using{' '}
          <a href="https://docs.claude.com/en/docs/claude-code/slash-commands" target="_blank" rel="noopener noreferrer">
            Slash commands
          </a>,{' '}
          <a href="https://docs.claude.com/en/docs/claude-code/sub-agents" target="_blank" rel="noopener noreferrer">
            Subagents
          </a>,{' '}
          <a href="https://docs.claude.com/en/docs/claude-code/plugins" target="_blank" rel="noopener noreferrer">
            Plugins
          </a>{' '}
          and{' '}
          <a href="https://docs.claude.com/en/docs/claude-code/skills" target="_blank" rel="noopener noreferrer">
            Skills
          </a>{' '}
          as desired.
        </li>
        <li>
          In Claude Code, run the following commands to install the ATXP Cloud plugin:
          <pre>
            /plugin marketplace add atxp-dev/claude{'\n'}
            /plugin install cloud@atxp{'\n'}
            /setup &lt;connection-string&gt;
          </pre>
          (your connection string is available at{' '}
          <a href="https://accounts.atxp.ai" target="_blank" rel="noopener noreferrer">
            accounts.atxp.ai
          </a>)
        </li>
        <li>
          When you are ready to deploy your customized version of Claude Code as a cloud agent, run:
          <pre>/deploy</pre>
          That's it! Your agent is now live in the cloud at a URL like{' '}
          <code>cloud.atxp.ai/{'{{random_string}}'}</code>; Claude will tell you where to find it.
        </li>
      </ol>

      <h2>Agents deployed to ATXP Cloud:</h2>

      <ul>
        <li>
          <strong>Are publicly accessible</strong>, but with a random, hard-to-guess URL—so you
          can share them if you'd like, and otherwise they should be almost impossible to find.
        </li>
        <li>
          <strong>Have isolated memory/runtime</strong> per user, while the capabilities
          (Slash commands, Subagents, Plugins, etc) are shared across all users.
        </li>
        <li>
          <strong>Are paid per-use</strong> by the end user, thanks to ATXP—with generous
          promotional credits so that getting started is free for all users.
        </li>
      </ul>

      <h2>A few other things:</h2>

      <ul>
        <li>
          If you{' '}
          <a href="https://github.com/atxp-dev/claude" target="_blank" rel="noopener noreferrer">
            use ATXP locally with Claude Code
          </a>, that will "just work" for anyone who uses your agent on ATXP Cloud—the system
          will populate the environment with <em>their</em> connection string instead of yours
          so that they're the ones paying.
        </li>
        <li>
          If your agent requires other environment variables to be populated, place them in{' '}
          <code>.atxp/.env.production</code> before deploying. <strong>Please note that these
          variables are legible to end-users at runtime</strong>, so be very careful with this.
          For per-user values, a better pattern is to define agent behavior (e.g. a Slash
          command or a subagent) which gathers those values from the user.
        </li>
      </ul>
    </div>
  );
}

export default LandingPage;
